<template>
<div>

		<div class="place-wrapper">
		<div class="place-block">
		<label for="amplitude" class="col1"><span class="bold col1">Amplitude</span> · <span id="amplitudeOut">{{ args.amplitude }}</span></label>
		<input class="col1b" @input="log" type="range" value="3" name="amplitude" id="amplitude" min="0.1" step="0.1" max="20"> 
		
		</div>

		<div class="place-block">
		<label class="col2" for="frequency"><span class="bold">Frequency</span> · <span id="frequencyOut">{{ args.frequency }}</span></label>
		<input @input="log" class="col2b" type="range" id="frequency" value="2" min="0.1" step="0.1" max="5" >
		</div>

		<div class="place-block">
		<label for="phase" class="col3"><span class="bold">Phase</span> · <span id="phaseOut">{{ args.phase }}</span></label>
		<input @input="log" type="range" class="col3b" value="1" id="phase" min="1"  max="10" >
		</div>
		</div>


	</div>
</template>

<script>

export default {
	methods: {
		log() {
			let id = event.srcElement.id; 
			let value = event.srcElement.value; 
			let e = document.getElementById(`${id}Out`);
			e.innerHTML = value;
			this.$emit('updating', {id:id,val:value})
		}
	},
	props: {
		args: Object,
	}
}

</script>

<style scoped>



.place-block {
	display: flex;
	flex-direction: column;
	padding: 5px;
	margin: 5px;
}



input { 
	max-width: 150px;
	margin: 0 auto;
}

input[type='range'] {
    -webkit-appearance: none !important;
    height:7px;
		border-radius: 5px;
}
input[type='range']::-webkit-slider-thumb {
    -webkit-appearance: none !important;
		outline: none;
		background: #ddd;
		border-radius: 50%;
    height:13px;
    width:13px;
}

label {
	padding: 10px 0px;
}

.place-wrapper {
	display:flex;
	justify-content: center;
	flex-direction: column;
}

div {
	text-transform: uppercase;
	font-size: 14px;
	font-weight: bold;
}

@media only screen and (min-width: 400px) {
  .place-wrapper {
		flex-direction: initial;
  }
	.place-block {
		width: 200px;
	}
}
</style>
